import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { Results } from './Results'

export interface ResultsRouteProps {
    isFullSize: boolean
}

export const ResultsRegistration = createRegisterableComponent(
    'stats-results',
    (props: ResultsRouteProps) => {
        return <Results isFullSize={props.isFullSize} />
    },
)
